import {
  RTE_SHORTCUT_INSERT_DIRECTIVE_VARIABLE,
  RTE_TOOLTIP_BOLD,
  RTE_TOOLTIP_BULLET_LIST,
  RTE_TOOLTIP_INSERT_HORIZONTAL_RULE,
  RTE_TOOLTIP_INSERT_VARIABLE,
  RTE_TOOLTIP_ITALIC,
  RTE_TOOLTIP_ORDERED_LIST,
  RTE_TOOLTIP_REDO,
  RTE_TOOLTIP_UNDO,
} from "@/constants/uiCopy/richTextEditor";

export type RteShortcutRow = { name: string; keys: string[] };

export const getRteShortcutKeys = (modKeyLabel: string) =>
  ({
    undo: [modKeyLabel, "Z"] as const,
    redo: [modKeyLabel, "⇧", "Z"] as const,
    bold: [modKeyLabel, "B"] as const,
    italic: [modKeyLabel, "I"] as const,
    bulletList: [modKeyLabel, "⇧", "8"] as const,
    orderedList: [modKeyLabel, "⇧", "7"] as const,
    horizontalRule: ["---"] as const,
    variable: ["{"] as const,
    directive: ["@"] as const,
  }) as const;

export const getRteShortcutRows = (modKeyLabel: string): RteShortcutRow[] => {
  const k = getRteShortcutKeys(modKeyLabel);
  return [
    { name: RTE_TOOLTIP_BOLD, keys: [...k.bold] },
    { name: RTE_TOOLTIP_ITALIC, keys: [...k.italic] },
    { name: RTE_TOOLTIP_UNDO, keys: [...k.undo] },
    { name: RTE_TOOLTIP_REDO, keys: [...k.redo] },
    { name: RTE_TOOLTIP_BULLET_LIST, keys: [...k.bulletList] },
    { name: RTE_TOOLTIP_ORDERED_LIST, keys: [...k.orderedList] },
    { name: RTE_TOOLTIP_INSERT_HORIZONTAL_RULE, keys: [...k.horizontalRule] },
    { name: RTE_TOOLTIP_INSERT_VARIABLE, keys: [...k.variable] },
    { name: RTE_SHORTCUT_INSERT_DIRECTIVE_VARIABLE, keys: [...k.directive] },
  ];
};
